import React from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { Messages } from 'primereact/messages';
import { Message } from 'primereact/message';
import Dropzone from 'react-dropzone';
import servicioExpediente from '../servicios/ServicioTcExpediente';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
export default class ModalSubirExpediente extends React.Component {
    constructor() {
        super();
        this.state = {
            mostrarMensaje:false,
            expediente:{},
            mostrarModal: false,
            formData: null,
            archivos: [],
            erroresRequeridos:{},
            estados_expediente: [
                { name: 'Visible para el usuario', code: 0 },
                { name: 'No visible para el usuario', code: 1 }
            ],
            estados_documento: [
                { name: 'Acta de nacimiento', code: 'Acta de nacimiento' },
                { name: 'INE', code: 'INE' },
                { name: 'Contrato Individual', code: 'Contrato Individual' },
                { name: 'Autorización para Contratación', code: 'Autorización para Contratación' },
                { name: 'Curp', code: 'Curp' },
                { name: 'Cedula de identificacion Fiscal', code: 'Cedula de identificacion Fiscal' },
                { name: 'Escolaridad', code: 'Escolaridad' },
                { name: 'Carta de recomendación', code: 'Carta de recomendación' },
                { name: 'Ficha de nuevo ingreso', code: 'Ficha de nuevo ingreso' },
                { name: 'Credito de vivienda', code: 'Credito de vivienda' },
                { name: 'Solicitud de empleo', code: 'Solicitud de empleo' },
                { name: 'Convenio Confidencialidad', code: 'Convenio Confidencialidad' },
                { name: 'Consentimiento polígrafo', code: 'Consentimiento polígrafo' },
                { name: 'Consentimiento toxicológico', code: 'Consentimiento toxicológico' },
                { name: 'Actualización de datos personales', code: 'Actualización de datos personales' },
            ],

        }

    }
    onDropDos = (files) => {
        let { archivos, expediente } = this.state;
        console.log(files.length);
        const validacion = this.validarFormulario(expediente);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            if (files.length <= 5) {
                for (var i = 0; i < files.length; i++) {
                    if (archivos.length <= 4) {
                        archivos.push(files[i]);
                    } else {
                        this.growl.show({ severity: 'error', summary: '', detail: 'El número maximo para subir son 5 convenios' });
                    }
                    // var cfdi = files[i];
                }
                // this.setState({ files2: formData });
                this.setState({ archivos });
            } else {
                this.growl.show({ severity: 'error', summary: '', detail: 'El lote máximo de convenios debe ser 5' });
            }
        }
    }
    guardarDocumentoDos() {
       
        this.messages.clear();
        let { tcIdentificador } = this.props;
        const id={};
        if(tcIdentificador != undefined){
           id.id=tcIdentificador.id;
        }else{
            id.id=0;
        }
        
        const { archivos, expediente } = this.state;
        const validacion = this.validarFormulario(expediente);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
            var expedienteEnvio = JSON.parse(JSON.stringify(expediente));
            let formData = new FormData();
            for (var i = 0; i < archivos.length; i++) {
                var cfdi = archivos[i];
                console.log(cfdi);
                formData.append('archivos', cfdi);
            }
            let estado = expedienteEnvio.tipo.code;
            let nombreDocumento = expedienteEnvio.nombreDocumento.code;

            servicioExpediente.procesarExpTra(formData, estado, nombreDocumento,id.id).then((response) => {
                this.setState({ mostrarMensaje: false });
                if (response.data.objeto.errores.length > 0) {

                    for (var i = 0; i < response.data.objeto.errores.length; i++) {
                        var valor = response.data.objeto.errores[i];
                        this.messages.show({ severity: 'error', summary: 'Error', detail: valor, sticky: true });
                    }
                }

                if (response.data.objeto.exitos.length > 0) {
                    for (var i = 0; i < response.data.objeto.exitos.length; i++) {
                        var valor = response.data.objeto.exitos[i];
                        this.messages.show({ severity: 'success', summary: 'Éxito', detail: valor, sticky: true });
                    }
                }
                this.setState({ files: [] });
                this.setState({ archivos: [], tcExpediente: {}, expediente: {} });
            }).catch((error) => {

            });
        }
    }
    onDropRejected = () => {
        this.growl.show({ severity: 'error', summary: '', detail: 'El archivo pesa  2MB' });
        //return this.props.errorNotice('Maximum file upload size is 2MB');
    }
    validarFormulario = (expediente) => {
        const errores = {};
        if (!expediente.tipo)
            errores.tipo = "El campo es requerido";
        if (!expediente.nombreDocumento)
            errores.nombreDocumento = "El campo es requerido";

        return errores;
    }
    resetEstados() {
        this.messages.clear();
        this.setState({
            mostrarModal: false,
            archivos: [],
            expediente:{},
            mostrarMensaje:false
        });
    }
    resetEstadosConfirmacion() {
                this.setState({
                mostrarMensaje:false
        });
    }
    asignarValoresObjeto = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    }
    mostrarModalConfirmacion(){
        const { expediente } = this.state;
        const validacion = this.validarFormulario(expediente);
        this.setState({ erroresRequeridos: validacion });
        if (!Object.keys(validacion).length) {
        this.setState({
            
            mostrarMensaje:true
        });
    }
    }
    render() {
        const archivos = this.state.archivos.length;
        let {  estados_documento,estados_expediente,erroresRequeridos,expediente} = this.state;
        const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-check" onClick={this.mostrarModalConfirmacion.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.resetEstados.bind(this)} className="p-button-danger " />
        </div>;
        const pieMensaje = <div className="ui-dialog-buttonpane p-clearfix">
        <Button label="Aceptar" icon="pi-md-check" onClick={this.guardarDocumentoDos.bind(this)} />
        <Button label="Cancelar" icon="pi-md-close" className="p-button-danger " onClick={this.resetEstadosConfirmacion.bind(this)} />
    </div>;
        return (
            <div className="p-fluid p-grid">
                <div className="p-col-4">
                    <Button className="p-button-Primary p-button-raised" label="Agregar Expediente"
                        icon="pi-md-plus" tooltip={"Agregar Archivos"} onClick={() => this.setState({ mostrarModal: true })} />
                </div>
                <Dialog visible={this.state.mostrarModal} style={{ width: '60%' }} header="Subir archivos" modal={true} footer={pieDialogo} onHide={this.resetEstados.bind(this)}>
                    <h4>Subir archivos</h4>
                    <Messages ref={(el) => this.messages = el}></Messages>
                    <div className="p-grid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="tipo">Visible:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Dropdown id="tipo" name="expediente.tipo" options={estados_expediente} value={expediente.tipo} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresRequeridos.tipo ? 'p-error' : ''} />
                            {erroresRequeridos.tipo ? <div> <Message severity="error" text={erroresRequeridos.tipo} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="tipo">Documento:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Dropdown id="nombreDocumento" name="expediente.nombreDocumento" options={estados_documento} value={expediente.nombreDocumento} onChange={this.asignarValoresObjeto} placeholder="Selecciona" optionLabel="name" className={erroresRequeridos.nombreDocumento ? 'p-error' : ''} />
                            {erroresRequeridos.nombreDocumento ? <div> <Message severity="error" text={erroresRequeridos.nombreDocumento} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-12">
                            <Dropzone maxSize={10000000} accept=".pdf" onDrop={this.onDropDos}>
                                {({ getRootProps, getInputProps }) => (
                                    <section className="container">
                                        <div  {...getRootProps({ className: 'dropzone rectangulo' })}>
                                            <input   {...getInputProps()} />
                                            <center><p>Arrastra tus archivos aquí</p></center>
                                        </div>
                                        <br></br>

                                        <aside>
                                            <h4>Cantidad de archivos a procesar</h4>
                                            <ul>{archivos}</ul>
                                        </aside>

                                    </section>
                                )}
                            </Dropzone>
                        </div>
                    </div>
                </Dialog>
                <Dialog visible={this.state.mostrarMensaje} style={{ width: '30%' }} modal={true} header="Confirmación" footer={pieMensaje} onHide={this.resetEstadosConfirmacion.bind(this)}>
                            <center><h4>¿Estas seguro de guardar los documentos?</h4></center>
                        </Dialog>
            </div>
        );
    }
}